import moment from "moment";
import formatValueCurrencyBRL from "../../../Utils/FormatCurrency/formatValueCurrency";

export class IgicPayFinancialTransactionReport {
    generateDocument(configs, results) {
        const infos = configs.clinic;
        var listFin = []
        results.forEach(element => {
            listFin.push([
              { text: element.emv, style: "body" },
              { text: element.customer?.name, style: "body" },
              { text: element.description, style: "body" },
              { text: element.status, style: "body" },

              {
                text: moment(element.dueDate).format("DD/MM/YYYY"),
                style: "body",
              },
              {
                text: formatValueCurrencyBRL(element.amountEmReais),
                style: "body",
              },
            ]);
        })
        var docDefinition = {
          pageSize: "A4",
          pageOrientation: "landscape", // 'landscape',
          header: {
            margin: [10, 10, 10, 10],
            columns: [
              infos.imageFile != undefined
                ? {
                    image: "data:image/jpeg;base64," + infos.file,
                    fit: [80, 80],
                    margin: [10, 20, 10, 10],
                    width: 100,
                  }
                : null,
              [
                {
                  text: infos.corporateName,
                  margin: [0, 20, 0, 0],
                  style: "corp",
                },
                {
                  text:
                    "Endereço: " +
                    infos.address +
                    ", " +
                    infos.bairro +
                    ", Cep: " +
                    infos.zipCode,
                  style: "corp",
                },
                {
                  text:
                    "Telefone: " +
                    infos.cellPhone +
                    (!infos.commercialPhone
                      ? ""
                      : (!infos.cellPhone ? "" : ", ") + infos.commercialPhone),
                  style: "corp",
                },
                { text: "Email: " + infos.email, style: "corp" },
                {
                  text: `${moment(configs.initialDate).format(
                    "DD/MM/YYYY"
                  )} a ${moment(configs.finalDate).format("DD/MM/YYYY")}`,
                  alignment: "center",
                  style: "corp",
                },
              ],
            ],
          },
          pageMargins: [15, 115, 15, 50], //left , top, right, bottom

          content: [
            {
              margin: [10, 5, 10, 10],
              layout: "lightHorizontalLines",
              table: {
                headerRows: 1,
                widths: [50, "auto", "*", "*", "*", "*"],
                body: [
                  [
                    { text: "Código Pix", style: "headerBody" },
                    { text: "Cliente", style: "headerBody" },
                    { text: "Descrição", style: "headerBody" },
                    { text: "Status", style: "headerBody" },
                    { text: "Vencimento", style: "headerBody" },
                    { text: "Valor", style: "headerBody" },
                  ],
                  ...listFin,
                ],
              },
            },
            {
              canvas: [
                { type: "line", x1: 0, y1: 0, x2: 805, y2: 0, lineWidth: 1 },
              ],
            },
            {
              alignment: "justify",
              columns: [
                {
                  with: 50,
                  text: `Resultados: ${results.length}`,
                },
                {
                  with: "auto",
                  text: "",
                },
                {
                  with: "*",
                  text: "",
                },
                {
                  with: "*",
                  text: "",
                },
                {
                  with: "*",
                  text: "",
                },
                {
                  with: "*",
                  text: `Valor total: ${formatValueCurrencyBRL(
                    results.reduce((a, b) => a + b.value, 0)
                  )}`,
                },
              ],
            },
          ],
          styles: {
            footerE: {
              fontSize: 10,
              bold: true,
            },
            footerR: {
              fontSize: 12,
              bold: true,
              alignment: "right",
            },
            footerR: {
              fontSize: 12,
              bold: true,
              alignment: "left",
            },
            headerBody: {
              fontSize: 10,
              alignment: "left",
            },
            corp: {
              fontSize: 10,
            },
            body: {
              fontSize: 8,
            },
            header: {
              fontSize: 22,
              bold: true,
              alignment: "left",
            },
          },
        };
        return docDefinition;
    }
}